export default __webpack_public_path__ + "static/media/html-5.feba840f.svg";